export default "__VITE_ASSET__9p576bC4__"